<script>
	import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';
    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';
    import { trackConversion } from '../helpers/tracking.svelte.js';
    import { registerConversionForReserve } from '../helpers/reserve.svelte.js';
    import { onMount } from 'svelte';

    import Section from '../components/Section.svelte';
    import Status from '../components/Status.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    import Appointment from '../components/Confirm/Appointment.svelte';
    import Waitlist from '../components/Confirm/Waitlist.svelte';

    const current = 'success';

    let url = $derived(window.location.origin + '/' + currentSession.client + '/' + currentSession.salon);

    // Track Google Ads conversion on success page load
    onMount(() => {
        const conversionData = {
            transaction_id: currentSession.id
        };

        if (currentSession.treatment?.price?.value) {
            conversionData.value = currentSession.treatment.price.value / 100;
            conversionData.currency = 'EUR';
        }

        trackConversion(conversionData);

        if (app.settings?.integrations?.reserve) {
            registerConversionForReserve();
        }
    });

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('success')}</title>
</svelte:head>

<Section title={$_('success')}>
    {#if currentSession.type === 'waitlist'}
        <Status icon="success">
            {$_('waitlist_success_title')}
        </Status>

        <p>
            {$_('waitlist_success_description')}
        </p>

        <Waitlist appointment={currentSession} />
    {:else}
        <Status icon="success">
            {$_('appointment_created')}
        </Status>

        <p>
            {$_('appointment_is_on')}
        </p>

        <Appointment appointment={currentSession} />

        <p>
            {$_('email_confirmation')}
        </p>
    {/if}

    <Navigation>
        <Button href={url}>
            {$_('make_another_appointment')}
            <Icon data={arrowRightIcon} />
        </Button>
    </Navigation>
</Section>